import { cva } from "class-variance-authority";

interface RibbonProps {
  label: string;
  size?: "m" | "l";
}

const ribbonVariants = cva(
  "pointer-events-none fixed top-0 right-0 w-72 origin-top bg-action-600 text-center shadow-md",
  {
    variants: {
      size: {
        m: "mt-9 mr-9",
        l: "mt-16 mr-16",
      },
    },
    defaultVariants: {
      size: "m",
    },
  },
);

export const Ribbon = ({ label, size }: RibbonProps) => {
  return (
    <div className={ribbonVariants({ size })} style={{ transform: "translateX(50%) rotate(45deg)" }}>
      <div className="typo-body-base-bold text-font-white">{label}</div>
    </div>
  );
};
